import React from 'react';

import { MenuItemProps } from '@mui/material';

import { Checkbox } from '~/components/Checkbox';

import { CheckboxOption } from './styled';

export const DropdownCheckboxOption = React.memo(
  function DropdownCheckboxOption<C extends React.ElementType>(
    props: MenuItemProps<C, { component?: C }>
  ) {
    const { children, selected, ...others } = props;

    return (
      <CheckboxOption selected={selected} {...others}>
        <Checkbox sx={{ py: '1px', px: '14px' }} checked={selected} />
        {children}
      </CheckboxOption>
    );
  }
);
